import React, { useEffect, useRef, useState } from 'react'
import ColumnsDevider from '../../../customControl/ColumnsDevider'
import Select from 'react-select';
import FileField from '../../../customControl/FileField';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../_actions/loader.actions';
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../components/commonClass/Session';
import { alphaNumericspace, ApiNotRespondMessage, onlyAlphabets } from '../../../components/commonClass/CommonValidation';
import { getDateCombination } from '../../../components/commonClass/CommonFunctions';
import { ImageDelete, ImageUpload } from '../../../ImageUpload/ImageCommon';
import { fileUpload } from '../../../components/commonClass/CommonInterfaceTypes';
import { AgentStatus } from '../../../_constants/agent.constant';

const CorporateAddOnInfo = (props: any) => {
  const { tabId, selectedTabId, setIsSaved, isConfirm, setIsConfirm, setIsRedirect, CorporateId, warnings, setWarningMessages, domainWiseDisable, statusId } = props
  const defaultFileUpload: fileUpload = {
    File: null,
    FileName: "",
    FilePath: "",
    Path: "",
    Size: 0,
    type: "",
    needToUpload: false
  }

  const OnboardingMessage = "Onboarding of Corporate is Successful."
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [dropdownList, setDropDownList] = useState<any>([])
  const [formErrors, setFormErrors] = useState<any>({})
  const [editcleardisabled, setEditClearDisabled] = useState(true)

  const acceptance = ".pdf, .doc, .docx, image/*"
  const maxFileSize = 10;
  const RegistrationDocumentRef = useRef<HTMLInputElement>(null);
  const PANCertificateRef = useRef<HTMLInputElement>(null);
  const SpecialAgreementRef = useRef<HTMLInputElement>(null);
  const [deleteRegistrationDocumentPath, setDeleteRegistrationDocumentPath] = useState<string>("");
  const [deletePANCertificatePath, setDeletePANCertificatePath] = useState<string>("");
  const [deleteSpecialAgreementPath, setDeleteSpecialAgreementPath] = useState<string>("");
  const [RegistrationDocument, setRegistrationDocument] = useState<fileUpload>(defaultFileUpload);
  const [PANCertificate, setPANCertificate] = useState<fileUpload>(defaultFileUpload);
  const [SpecialAgreement, setSpecialAgreement] = useState<fileUpload>(defaultFileUpload);
  const handleimageupload = async (pathdirectory: string, filename: string, file: any) => {
    await ImageUpload(pathdirectory, filename, file);
  };

  const handleimageDelete = async (filename: string) => {
    await ImageDelete(filename);
  };

  const [formValue, setFormValue] = useState({
    CorporateId: 0,
    CorporateAddOnInfoId: 0,
    LeadSourceMasterId: 0,
    LeadSourceOtherRemark: '',
    Remarks: '',
    AgencyRegistrationDocName: '',
    AgencyRegistrationDocPath: '',
    PANDocName: '',
    PANDocPath: '',
    SpecialAgreementDocName: '',
    SpecialAgreementDocPath: '',
    UserId: 0,
  })

  const getdropdowndata = async () => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData('/midoffice/v1/getaddoninfooption')
      if (list?.status) {
        const leadSourceOption = list?.data?.leadSourceOption?.map((obj: any) => ({
          label: obj?.LeadSource,
          value: obj?.LeadSourceMasterId,
        })) ?? [];
        setDropDownList({ leadSourceOption });
      }
      else {
        setDropDownList([]);
      }
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
    dispatch(loaderActions.end());
  }

  const onChange = (name: any, val: any) => {
    setFormErrors({});
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }))
    setEditClearDisabled(false);
    if (name === 'LeadSourceMasterId') {
      setFormValue((form: any) => ({ ...form, [name]: val }))
      if (val !== 1) {
        setFormValue((form: any) => ({ ...form, LeadSourceOtherRemark: '' }))
      }
    }
    else {
      setFormValue((form: any) => ({ ...form, [name]: val }))
    }
  }

  const validation = () => {
    setWarningMessages([]);
    let status: boolean = true;
    const error: any = {}
    if (formValue?.LeadSourceOtherRemark?.trim()?.length === 0 && formValue.LeadSourceMasterId === 1) {
      error.LeadSourceOtherRemark = "Please provide details for Lead Source Remark";
      status = false;
    }
    // const WarningAssignment = warnings?.Assignment?.warningValidation()
    // if (selectedTabId === tabId && WarningAssignment) {
    //   setWarningMessages((prev: any) => ([...prev, WarningAssignment]))
    //   status = false;
    // }
    setFormErrors(error);
    return status;
  }


  const saveDate = async () => {
    setIsConfirm(isConfirm === 1 && selectedTabId === tabId ? 2 : 0);
    if (validation()) {
      dispatch(loaderActions.start());
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let user: any = GetLocalStorage();
        formValue.UserId = user?.userMasterID
        formValue.CorporateId = Number(formValue.CorporateId)
        const RpsData = await postUsersData("/midoffice/v1/insertorupdatecorporateaddoninfo", formValue);
        if (RpsData?.status) {
          setIsSaved((save: any) => ({ ...save, AddOnInfo: true }))
          setIsRedirect(true);
          setFormErrors({})
          if (RegistrationDocument?.needToUpload && isValidAddonFile(RegistrationDocument?.type, RegistrationDocument?.FileName)) {
            Promise.allSettled([
              deleteRegistrationDocumentPath !== "" && await handleimageDelete(deleteRegistrationDocumentPath),
              await handleimageupload(RegistrationDocument?.Path, RegistrationDocument?.FileName, RegistrationDocument?.File)
            ])
          }
          if (PANCertificate?.needToUpload && isValidAddonFile(PANCertificate?.type, PANCertificate?.FileName)) {
            Promise.allSettled([
              deletePANCertificatePath !== "" && await handleimageDelete(deletePANCertificatePath),
              await handleimageupload(PANCertificate?.Path, PANCertificate?.FileName, PANCertificate?.File)
            ])
          }
          if (SpecialAgreement?.needToUpload && isValidAddonFile(SpecialAgreement?.type, SpecialAgreement?.FileName)) {
            Promise.allSettled([
              deleteSpecialAgreementPath !== "" && await handleimageDelete(deleteSpecialAgreementPath),
              await handleimageupload(SpecialAgreement?.Path, SpecialAgreement?.FileName, SpecialAgreement?.File)
            ])
          }
          dispatch({ type: 'ALERTINGMESSAGE', message: OnboardingMessage, path: '/corporate-management' });
        }
        else {
          dispatch({ type: 'ALERTING', message: RpsData?.message || ApiNotRespondMessage })
        }
        dispatch(loaderActions.end());
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        dispatch(loaderActions.end());
      }

    }
  }

  const getbyid = async (id: any) => {
    dispatch(loaderActions.start());
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      const list = await getAllData(`/midoffice/v1/getcorporateaddoninfobyid?corporateid=${id}`)
      if (list?.status && list?.data) {
        setFormValue({
          CorporateAddOnInfoId: list?.data?.[0]?.CorporateAddOnInfoId ? list?.data?.[0]?.CorporateAddOnInfoId : 0,
          CorporateId: Number(id),
          AgencyRegistrationDocName: list?.data?.[0]?.AgencyRegistrationDocName ? list?.data?.[0]?.AgencyRegistrationDocName : '',
          AgencyRegistrationDocPath: list?.data?.[0]?.AgencyRegistrationDocPath ? list?.data?.[0]?.AgencyRegistrationDocPath : '',
          LeadSourceMasterId: list?.data?.[0]?.LeadSourceMasterId ? list?.data?.[0]?.LeadSourceMasterId : 0,
          LeadSourceOtherRemark: list?.data?.[0]?.LeadSourceOtherRemark ? list?.data?.[0]?.LeadSourceOtherRemark : '',
          PANDocName: list?.data?.[0]?.PANDocName ? list?.data?.[0]?.PANDocName : '',
          PANDocPath: list?.data?.[0]?.PANDocPath ? list?.data?.[0]?.PANDocPath : '',
          Remarks: list?.data?.[0]?.Remarks ? list?.data?.[0]?.Remarks : '',
          SpecialAgreementDocName: list?.data?.[0]?.SpecialAgreementDocName ? list?.data?.[0]?.SpecialAgreementDocName : '',
          SpecialAgreementDocPath: list?.data?.[0]?.SpecialAgreementDocPath ? list?.data?.[0]?.SpecialAgreementDocPath : '',
          UserId: 0,
        })
        const staticFilePath = "https://static-ethics.sgp1.digitaloceanspaces.com/etm/"
        setDeleteRegistrationDocumentPath(list?.data?.[0]?.AgencyRegistrationDocPath ? `${staticFilePath}${list?.data?.[0]?.AgencyRegistrationDocPath}` : "");
        setDeletePANCertificatePath(list?.data?.[0]?.PANDocPath ? `${staticFilePath}${list?.data?.[0]?.PANDocPath}` : "");
        setDeleteSpecialAgreementPath(list?.data?.[0]?.SpecialAgreementDocPath ? `${staticFilePath}${list?.data?.[0]?.SpecialAgreementDocPath}` : "");
      }
      dispatch(loaderActions.end());
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      dispatch(loaderActions.end());
    }
  }

  const isValidAddonFile = (type: string, name: string) => {
    if (type?.includes('image')) {
      return true;
    }
    else {
      return /\.(pdf|doc|docx)$/i.test(name)
    }
  }

  const handleFileUpload = (name: string, e: any) => {
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    const file = e.target.files?.[0];
    const dateCombination = getDateCombination();
    const fileName = dateCombination + '_1_' + (file?.name?.replace(/ /g, "_"))?.replace(/-/g, '');
    const filePath = `MO/CorporateManagement/${name}/${fileName}`;
    const path = `MO/CorporateManagement/${name}/`;
    const fileSize = (file?.size / 1024) / 1024;
    const fileType = file?.type

    const fileData: fileUpload = {
      File: file ? file : null,
      FileName: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? fileName : "",
      FilePath: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? filePath : "",
      Path: file ? path : "",
      Size: file ? fileSize : 0,
      type: file ? fileType : "",
      needToUpload: file && isValidAddonFile(fileType, fileName) && fileSize < maxFileSize ? true : false
    }
    setEditClearDisabled(file ? false : editcleardisabled);

    if (name === "RegistrationDocument") {
      setRegistrationDocument(fileData);
      setFormValue((form) => ({
        ...form,
        AgencyRegistrationDocName: fileData?.FileName,
        AgencyRegistrationDocPath: fileData?.FilePath,
      }))
    }
    else if (name === "PANCertificate") {
      setPANCertificate(fileData);
      setFormValue((form) => ({
        ...form,
        PANDocName: fileData?.FileName,
        PANDocPath: fileData?.FilePath,
      }))
    }
    else if (name === "SpecialAgreement") {
      setSpecialAgreement(fileData);
      setFormValue((form) => ({
        ...form,
        SpecialAgreementDocName: fileData?.FileName,
        SpecialAgreementDocPath: fileData?.FilePath,
      }))
    }

  }

  const clearData = () => {
    setIsSaved((save: any) => ({ ...save, AddOnInfo: false }));
    setFormValue((form) => ({
      ...form,
      LeadSourceMasterId: 0,
      LeadSourceOtherRemark: "",
      Remarks: "",
      AgencyRegistrationDocName: "",
      AgencyRegistrationDocPath: "",
      PANDocName: "",
      PANDocPath: "",
      SpecialAgreementDocName: "",
      SpecialAgreementDocPath: "",
    }));
    setRegistrationDocument(defaultFileUpload);
    setPANCertificate(defaultFileUpload);
    setSpecialAgreement(defaultFileUpload);

    if (RegistrationDocumentRef.current !== null) {
      RegistrationDocumentRef.current.value = ""
    }
    if (PANCertificateRef.current !== null) {
      PANCertificateRef.current.value = ""
    }
    if (SpecialAgreementRef.current !== null) {
      SpecialAgreementRef.current.value = ""
    }
  }

  useEffect(() => {
    if (CorporateId) {
      setFormValue((form) => ({ ...form, CorporateId: Number(CorporateId) }));
      getbyid(CorporateId)
    }
  }, [CorporateId])

  useEffect(() => {
    getdropdowndata();
  }, [])

  useEffect(() => {
    if (isConfirm === 1 && selectedTabId === tabId) {
      saveDate()
    }
  }, [isConfirm])

  return (
    <div className='row mt-5'>
      <ColumnsDevider label='Lead Source'>
        <Select
          className="dropdown select_dropdown custom_class"
          options={dropdownList?.leadSourceOption}
          value={dropdownList?.leadSourceOption?.filter((leadSourceOption: any) => {
            return leadSourceOption.value === formValue.LeadSourceMasterId;
          })}
          onChange={(e: any) => onChange('LeadSourceMasterId', e?.value)}
          isDisabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
          isSearchable={true}
          isClearable
        />
      </ColumnsDevider>

      <ColumnsDevider label=''><div></div></ColumnsDevider>
      <div className='col-md-3 col-12 pb-2'></div>
      <div className='col-md-7 col-12 pb-2'>
        <input
          type='text'
          className='form-control mb-lg-1'
          name="LeadSourceOtherRemark"
          id="LeadSourceOtherRemark"
          placeholder='Other Text'
          value={formValue?.LeadSourceOtherRemark}
          onChange={(e: any) => {
            e.target.value?.length <= 100 &&
              onChange("LeadSourceOtherRemark", onlyAlphabets(e?.target?.value))
          }}
          maxLength={100}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser || formValue?.LeadSourceMasterId !== 1}
        />
        {formErrors?.LeadSourceOtherRemark && <div className='text-danger text-start fs_14'>{formErrors?.LeadSourceOtherRemark}</div>}
      </div>

      <div className='col-md-3 col-12'> Remarks </div>
      <div className='col-md-7 col-12'>
        <textarea
          className='form-control'
          name="Remarks"
          id="Remarks"
          rows={10}
          placeholder='Remarks'
          value={formValue.Remarks}
          onChange={(e: any) => {
            e?.target?.value?.length <= 200 &&
              onChange('Remarks', alphaNumericspace(e?.target?.value))
          }}
          maxLength={200}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
        />
      </div>

      <div className='mb-2'><h4 className='fw-bold'>Attachments</h4></div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="RegistrationDocument" className="col-form-label">Agency Registration Document</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={RegistrationDocumentRef}
          id="RegistrationDocument"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("RegistrationDocument", e)}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.AgencyRegistrationDocName && <div className='fs_14 text-truncate'> {formValue?.AgencyRegistrationDocName} </div>}
      </div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="PANCertificate" className="col-form-label">PAN Card/TIN Certificate</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={PANCertificateRef}
          id="PANCertificate"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("PANCertificate", e)}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.PANDocName && <div className='fs_14 text-truncate'> {formValue?.PANDocName} </div>}
      </div>

      <div className='col-md-6 col-12 my-2'>
        <label htmlFor="SpecialAgreement" className="col-form-label">Special Agreement</label>
      </div>
      <div className='col-md-4 col-12 my-2'>
        <FileField
          ref={SpecialAgreementRef}
          id="SpecialAgreement"
          accept={acceptance}
          onChange={(e: any) => handleFileUpload("SpecialAgreement", e)}
          disabled={location?.state?.disabled || domainWiseDisable?.isExternalUser}
        />
        {formValue?.SpecialAgreementDocName && <div className='fs_14 text-truncate'> {formValue?.SpecialAgreementDocName} </div>}
      </div>

      <div className="mt-3 d-flex justify-content-center mt-5">
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={location?.state?.disabled || editcleardisabled || domainWiseDisable?.isExternalUser} onClick={() => saveDate()} id="btnAdd">
          {domainWiseDisable?.loginUserDomainMasterId !== 1 ? (statusId === AgentStatus.Rejected ? "Re-Submit" : "Submit") : (location?.state?.viewtype === 'Update' ? 'Update' : 'Finish')}
        </button>
        <button type="button" className="btn btn-primary mx-1 px-3" disabled={editcleardisabled || location?.state?.disabled || domainWiseDisable?.isExternalUser} onClick={() => clearData()} id="btnAdd">Clear</button>
        <button type="button" className="btn btn-primary mx-1 px-3" onClick={() => navigate('/corporate-management')} id="btnClear">Back</button>
      </div>

    </div>
  )
}

export default CorporateAddOnInfo